<script lang="ts">
  export let value: number
  export let min: string | undefined = undefined
  export let max: string | undefined = undefined

  let minValue: number = min === undefined ? Number(0) : Number(min)
  let maxValue: number = max === undefined ? Number(100) : Number(max)

  let widthSlider: number

  $: percentageShown = ((value - minValue) / (maxValue - minValue)) * 100
  $: progressThumb = ((widthSlider - 26) / 100) * percentageShown
</script>

<div bind:clientWidth={widthSlider} class="w-full relative">
  <input
    style="--tw-gradient-to-position:{percentageShown}%;--tw-gradient-from-position:{percentageShown}%;"
    type="range"
    bind:value
    {...$$restProps}
    class="w-full appearance-none border-green border-2 bg-transparent [&::-webkit-slider-runnable-track]:bg-gradient-to-r from-green to-black [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-6 [&::-webkit-slider-thumb]:w-6 [&::-webkit-slider-thumb]:bg-darkgreen"
    on:change
    on:click
    on:keydown
    on:keypress
    on:keyup
    {min}
    {max}
  />
  <div class="bg-darkgreen w-[26px] h-10 -top-1.5 absolute pointer-events-none px-2 py-3 flex justify-between" style="transform: translateX({progressThumb}px);">
    <span class="w-0.5 h-full bg-white" />
    <span class="w-0.5 h-full bg-white" />
  </div>
</div>
